export const numberFormat = (number, options) => {
  const instance = new Intl.NumberFormat('en-UK', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options
  });

  return instance.format(number);
};

export const formatEnergy = (value, unit, options = {}) =>
  `${numberFormat(value, options)}${unit === 'kwh' ? ' kWh' : ''}`;
